<mat-horizontal-stepper color="accent" [linear]="true">
  <mat-step [completed]="false">
    <ng-template matStepLabel>Upload DocX</ng-template>

    @if (error$ | async; as error) {
      <semeris-error>{{ error }}</semeris-error>
    }

    <semeris-file-uploader
      [accept]="accept"
      [allowedMimeTypes]="allowedMimeTypes"
      [multiple]="false"
      (filesSelected)="onFilesSelected($event)"
      (invalidFiles)="onInvalidFilesSelected($event)"
      >
    </semeris-file-uploader>
  </mat-step>

  <mat-step [completed]="false">
    <ng-template matStepLabel>Confirmation</ng-template>

    @if (loading$ | async) {
      <semeris-loader [loading]="true"></semeris-loader>
    } @else {
      <div class="confirmation-container">
        <p>
          Are you sure you want to upload the <b>{{ (file$ | async)?.name }}</b
          >?
        </p>
        <semeris-warning>This action will replace the existing acro docx and will trigger the upload process again.</semeris-warning>
        <div class="fill-space"></div>
        <div class="controls">
          <button semerisButton variant="raised" color="warn" (click)="onCancel()">Cancel</button>
          <button semerisButton variant="raised" color="accent" (click)="onConfirm()">Confirm</button>
        </div>
      </div>
    }

  </mat-step>

  <mat-step [editable]="false">
    <ng-template matStepLabel>Starting upload...</ng-template>

    <div class="final-step">
      <p>You will receive a slack message when the transaction is published.</p>
    </div>

    <div class="controls">
      <button semerisButton variant="text" (click)="onClose()">Close</button>
    </div>
  </mat-step>
</mat-horizontal-stepper>

<button class="close-button" semerisIconButton mat-dialog-close><mat-icon>close</mat-icon></button>

